export const LOADER_STATUS = "boilerplate/Notices/EmailMaster/LOADER_STATUS";
export const EMAIL_MASTER_DATA = "boilerplate/Notices/EmailMaster/EMAIL_MASTER_DATA";

